import { createFileRoute } from "@tanstack/react-router";
import { PharmacyGroupsPage } from "@/features/admin/pharmacy-groups-page";
import { ensureAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/grupy-aptek")({
	beforeLoad: async () => {
		await ensureAdminAccess();
	},
	component: PharmacyGroupsPage,
});
